<template>
  <div :class="$style.wrapper">
    <img src="../assets/img/logo.svg" alt="" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" module>
@keyframes fade {
  from {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.wrapper {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: $background;
  img {
    width: 100px;
    animation-name: fade;
    animation-duration: 1.25s;
    animation-delay: 0.5s;
    animation-iteration-count: infinite;
    opacity: 0;
  }
}
</style>
